import React from 'react';
import AboutUs from '../AboutUs/AboutUs';

const ModuleAboutUs = ({
  aboutUsVersion,
  primaryColor,
  secondaryColor,
  companyName,
  aboutUsDetails,
  isMobile,
}) => {
  return (
    <AboutUs
      isMobile={isMobile}
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      aboutUsVersion={aboutUsVersion}
      aboutUsDetails={aboutUsDetails}
      companyName={companyName}
    />
  );
};

export default ModuleAboutUs;
